import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/shop/register/page.tsx");
